import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

interface PillarCard {
  slug: string;
  icon: string;
  titleKey: string;
  descKey: string;
  accentClass: string;
}

const pillars: PillarCard[] = [
  {
    slug: "usfans-spreadsheet-guide",
    icon: "ri-table-line",
    titleKey: "pillar.spreadsheet.title",
    descKey: "pillar.spreadsheet.desc",
    accentClass: "bg-primary-100 text-primary-700",
  },
  {
    slug: "usfans-review",
    icon: "ri-star-line",
    titleKey: "pillar.review.title",
    descKey: "pillar.review.desc",
    accentClass: "bg-accent-100 text-accent-700",
  },
  {
    slug: "usfans-shipping-cost-guide",
    icon: "ri-truck-line",
    titleKey: "pillar.shipping.title",
    descKey: "pillar.shipping.desc",
    accentClass: "bg-secondary-100 text-secondary-700",
  },
  {
    slug: "usfans-coupon-guide",
    icon: "ri-coupon-3-line",
    titleKey: "pillar.coupon.title",
    descKey: "pillar.coupon.desc",
    accentClass: "bg-primary-100 text-primary-700",
  },
  {
    slug: "usfans-discount-code-guide",
    icon: "ri-price-tag-3-line",
    titleKey: "pillar.discount.title",
    descKey: "pillar.discount.desc",
    accentClass: "bg-accent-100 text-accent-700",
  },
  {
    slug: "usfans-warehouse-guide",
    icon: "ri-archive-line",
    titleKey: "pillar.warehouse.title",
    descKey: "pillar.warehouse.desc",
    accentClass: "bg-secondary-100 text-secondary-700",
  },
  {
    slug: "is-usfans-legit",
    icon: "ri-shield-check-line",
    titleKey: "pillar.legit.title",
    descKey: "pillar.legit.desc",
    accentClass: "bg-primary-100 text-primary-700",
  },
  {
    slug: "usfans-qc-guide",
    icon: "ri-search-eye-line",
    titleKey: "pillar.qc.title",
    descKey: "pillar.qc.desc",
    accentClass: "bg-accent-100 text-accent-700",
  },
  {
    slug: "usfans-beginner-buying-guide",
    icon: "ri-bookmark-line",
    titleKey: "pillar.beginner.title",
    descKey: "pillar.beginner.desc",
    accentClass: "bg-secondary-100 text-secondary-700",
  },
  {
    slug: "usfans-safety-guide",
    icon: "ri-lock-password-line",
    titleKey: "pillar.safety.title",
    descKey: "pillar.safety.desc",
    accentClass: "bg-primary-100 text-primary-700",
  },
];

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            {t("pillars.title")}
          </h2>
          <p className="text-foreground-600 mt-4 leading-relaxed">
            {t("pillars.desc")}
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
        {pillars.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 5) * 60}>
            <Link
              to={`/guides/${p.slug}`}
              className="group flex flex-col h-full rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer p-5"
            >
              <div className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${p.accentClass}`}>
                <i className={`${p.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 leading-tight">
                {t(p.titleKey)}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed flex-1">
                {t(p.descKey)}
              </p>
              <div className="flex items-center gap-1 mt-4 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all">
                {t("readMore")}
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}